import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import AgencyConnectionsExportContent from "./AgencyConnectionsExportContent";
import {withRouterParams} from "../../utils/withRouterParams";

class AgencyConnectionsExport extends Component {
    getOnBoardingStatus() {
        if (this.props.location.state === undefined || this.props.location.state === null) {
            return false
        } else {
            return this.props.location.state.showOnBoarding
        }
    }

    render() {

        return (
            <div className="app-content">
                <LayoutSidebar showOnBoarding={this.getOnBoardingStatus()}/>
                <AgencyConnectionsExportContent agencyId={this.props.match.params.id}/>
            </div>
        )
    }
}

export default withRouterParams(AgencyConnectionsExport);

